module.exports = __webpack_public_path__ + "static/bahamut_young_monk_fight_young_red_dragon-50f9995cefd61d5efe0a66dd91069db2.jpg";